import { Text } from '@avanta/shared/components/Text';
import { Dialog } from '@avanta/shared/components/ui/Dialog';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { Trans, useTranslation } from 'react-i18next';
import { useBanAdmin } from './useBanAdmin';

export const BanAdministratorDialog = ({ adminId }: { adminId: string }): React.ReactElement => {
  const { mutate: banAdmin, isPending } = useBanAdmin();
  const { hideDialog } = useDialogContext();
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  const handleBanAdministrator = (): void => {
    banAdmin(adminId);
  };

  return (
    <Dialog
      className="max-h-131 overflow-y-auto w-3xl"
      title={t('BanAdministratorDialog.heading')}
      secondaryAction={{
        label: t('BanAdministratorDialog.cancel'),
        variant: 'destructive_terciary',
        action: hideDialog,
        size: 'lg',
      }}
      primaryAction={{
        label: t('BanAdministratorDialog.confirm'),
        action: handleBanAdministrator,
        variant: 'destructive',
        size: 'lg',
        isLoading: isPending,
      }}
      open
      enableOutsideClick={false}
    >
      <Text variant="text-md-regular" className="text-denim-500">
        <Trans i18nKey="BanAdministratorDialog.body" ns={LOCIZE_NS.INSURANCE} />
      </Text>
    </Dialog>
  );
};
